import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import tokenProvider from '../../utils/token';

interface Input extends RouteProps {
  authenticatedComponent: any;
}

export function getCookie(cname: string) {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

const PrivateRoute = (props: Input) => {
  
  const token = tokenProvider.getToken();
  if (token) {
    return <Route {...props} component={props.authenticatedComponent} />;
  }
  return <Route {...props} render={() => <Redirect to="/login" />} />;
};

export default PrivateRoute;
